// @flow
import { camelize, snakeify } from '@rover/utilities/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';
import { getAxiosInstance } from '@rover/utilities/axiosUtils';
import type { ExpressParams } from '@rover/react-lib/types';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

const buildPersonSummaryUrl = (personUrl: string) => `${personUrl}summary/`;
export const PERSON_SUMMARY_URL = fullApiUrl('me/');

export const get = async (personUrl: ?string, expressParams: ?ExpressParams): Promise<any> => {
  const ai = getAxiosInstance(expressParams);

  try {
    const { data } = await ai.get(
      personUrl ? buildPersonSummaryUrl(personUrl) : PERSON_SUMMARY_URL
    );
    return camelize(data, true);
  } catch (e) {
    const { response } = e;
    if (response && response.status === 404) {
      return [];
    }
    return DefaultAPIErrorHandler(e, "There was an error fetching person's summary.");
  }
};

export const save = async (
  personData: any,
  personUrl: ?string,
  expressParams: ?ExpressParams
): Promise<any> => {
  const ai = getAxiosInstance(expressParams);
  try {
    const { data } = await ai.patch(personUrl || personData.url, snakeify(personData, true));
    return camelize(data, true);
  } catch (e) {
    const { response } = e;
    if (response && response.status === 404) {
      return [];
    }
    return DefaultAPIErrorHandler(e, "There was an error saving person's summary.");
  }
};



// WEBPACK FOOTER //
// ../react-lib/src/apis/personSummary.api.js